import { render } from "./LbrxPaymentPopup.vue?vue&type=template&id=15a2b026&scoped=true"
import script from "./LbrxPaymentPopup.vue?vue&type=script&lang=js"
export * from "./LbrxPaymentPopup.vue?vue&type=script&lang=js"

import "./LbrxPaymentPopup.vue?vue&type=style&index=0&id=15a2b026&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2b026"]])

export default __exports__